export default class ParametroConsultaRevocatorias{

    constructor() {
        this.Identificacion = "";
        this.TipoPersona = null;
        this.FechaTramiteDesde = "";
        this.FechaTramiteHasta = "";
        this.NumeroRevocacion = "";
        this.IdEntidad = "";
        this.UsuarioTramiteIdentificacion = "";
    }

    Identificacion: string;
    TipoPersona: any;
    FechaTramiteDesde: string;
    FechaTramiteHasta: string;
    NumeroRevocacion: string;
    IdEntidad: string;
    UsuarioTramiteIdentificacion: string;
}

